import { Grid, Stack } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "src/app/main/utilities/AgGridTable";

const expenseListURL = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.expenseClaimList}`;

const LeaveDetails = () => {
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const [rowData, setRowData] = useState([
    {
      leaveType: "Annual Leave",
      allowedDays: "22.0",
      consumed: "15.0",
      balance: "7.0",
      nature: "Paid",
    },
    {
      leaveType: "Paid Sick Leave",
      allowedDays: "22.0",
      consumed: "15.0",
      balance: "7.0",
      nature: "Paid",
    },
    {
      leaveType: "Half Paid Sick Leave",
      allowedDays: "22.0",
      consumed: "15.0",
      balance: "7.0",
      nature: "Half Paid",
    },
    {
      leaveType: "Unpaid Leave",
      allowedDays: "22.0",
      consumed: "15.0",
      balance: "7.0",
      nature: "UnPaid",
    },
  ]);
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "leaveType",
      headerName: "Leave Type",
      filter: "agNumberColumnFilter",
    },
    {
      field: "allowedDays",
      headerName: "Allowed Days",
      // cellRenderer: PostingCheckboxRenderer,
    },
    {
      field: "consumed",
      headerName: "Consumed",
      // cellRenderer: InventoryCheckboxRenderer,
    },
    {
      field: "balance",
      headerName: "Balance",
    },
    {
      field: "nature",
      headerName: "Nature",
    },
  ]);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    try {
      const list = await OAuthService.getList(expenseListURL);
      let expenseClaimList = list.data._embedded.expenses;
      // console.log(expenseClaimList);
      // setRowData(expenseClaimList);
    } catch (error) {
      setError(error.message);
    }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);
  const onRowDoubleClicked = (params) => {
    navigate("/payroll/employee/profile");
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };
  const getContextMenuItems = (event) => {
    var result = [
      {
        name: "Edit",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: (props) => {
          navigate(`/expense-claim/add?id=${event.node.data.id}`);
        },
      },

      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onDelete(event);
        },
      },
    ];
    return result;
  };
  return (
    <AgGridTable
      columnDefs={columnDefs}
      onGridReady={onGridReady}
      gridRef={gridRef}
      rowData={rowData}
      getContextMenuItems={getContextMenuItems}
      editable={false}
      pagination={false}
      hideCheckbox={true}
      onSelectionChanged={onSelectionChanged}
      onRowDoubleClicked={onRowDoubleClicked}
    />
  );
};

export default LeaveDetails;
